export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZboziDruh';
export const NAME = 'Zbozidruh';
